// index.js
// Entry point for the React app

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Create the root element and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
